import { getWeekStartByLocale } from 'weekstart';
import { endOfWeek as endOfWeekFNS } from 'date-fns';

export const endOfWeek = (date: Date | number) => {
  return endOfWeekFNS(date, {
    weekStartsOn: getWeekStartByLocale(navigator.language),
  });
};
